import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { CpPlansConsentsModal } from '../../../helpers/objects/dto/client-portal/consents/cp-plans-consents-modal';
import {
  CpConsentsRequestResponseModal,
  CpConsentsRequestConsentModal
} from '../../../helpers/objects/dto/client-portal/consents/cp-consents-request-response-modal';

@Injectable({
  providedIn: 'root'
})
export class CpPlansConsentsService {
  appConfig: EnvironmentModel = new EnvironmentModel();
  adhesionApi: string = '';

  constructor(@Inject(APP_CONFIG) appConfigTemp: EnvironmentModel,
              private http: HttpClient) {
    this.appConfig = appConfigTemp;
    this.adhesionApi = this.appConfig.api.replace('/fhcp/', '/adhesion/');
  }

  get(id: string) {
    return this.http.get<any>(this.appConfig.api + 'products/' + id + '/consents').pipe(
      map(response => response.body as CpPlansConsentsModal[])
    );
  }

  getConsentsRequest(id: string): Observable<CpConsentsRequestResponseModal> {
    const headers = new HttpHeaders({ 'X-AppContext': this.appConfig.apiAppContext });
    return this.http.get<any>(this.adhesionApi + 'consents-requests/' + id, { headers }).pipe(
      map(response => {
        const body = response.body;
        return new CpConsentsRequestResponseModal({
          name: body.name,
          email: body.email,
          guid: body.guid,
          consents: (body.consents || []).map((c: any) => new CpConsentsRequestConsentModal({
            id: c.id,
            resume: c.resume,
            minAge: c.minAge,
            checked: c.checked || false,
            htmlText: c.htmlText || '',
            requiredForSubscription: c.requiredForSubscription || false,
            requiredForSubscriptions: c.requiredForSubscription || false
          }))
        });
      })
    );
  }

  setConsentsRequest(id: string, consents: Array<{ consentTypeId: number; consentAccepted: boolean }>): Observable<any> {
    const headers = new HttpHeaders({ 'X-AppContext': this.appConfig.apiAppContext });
    return this.http.post<any>(this.adhesionApi + 'consents-requests/' + id, { consents }, { headers });
  }
}
